/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  BUILDING_MODS_COLUMN_PIER_SPANDREL_RATIO,
  BUILDING_MODS_COLUMN_RATIO_LESS_THAN_TYPICAL,
  BUILDING_MODS_CONSTRUCTION_QUALITY,
  BUILDING_MODS_CROSS_GRAIN_OOP_CONN,
  BUILDING_MODS_DIAPHRAGM_DEFICIENCY,
  BUILDING_MODS_DIAPHRAM_OPEN,
  BUILDING_MODS_FLAT_PLATE_AS_BEAM,
  BUILDING_MODS_FULL_STORY_GRADE,
  BUILDING_MODS_FULL_STORY_GRADE_WLF,
  BUILDING_MODS_INTERIOR_WALL_DENSITY,
  BUILDING_MODS_K_BRACING,
  BUILDING_MODS_LIFT_SLAB_CONSTRUCTION,
  BUILDING_MODS_MATERIAL_DETERIORATION,
  BUILDING_MODS_NON_PARALLEL,
  BUILDING_MODS_NON_STRUCTURAL_CONSTRUCTION_QUALITY,
  BUILDING_MODS_OOP_OFFSET,
  BUILDING_MODS_OTHER_PLAN_IRREGULARITY,
  BUILDING_MODS_OTHER_VERTICAL_IRREGULARITY,
  BUILDING_MODS_PANEL_ZONE_DEFICIENCY,
  BUILDING_MODS_POUNDING_DIFFERENT_BUILDING_HEIGHTS,
  BUILDING_MODS_POUNDING_END_OF_BLOCK,
  BUILDING_MODS_POUNDING_FLOORS_UNALIGNED,
  BUILDING_MODS_REDUNDANCY,
  BUILDING_MODS_REENTRANT,
  BUILDING_MODS_SETBACK_INBOARD,
  BUILDING_MODS_SETBACK_IN_PLANE_LFRS,
  BUILDING_MODS_SETBACK_OUTBOARD,
  BUILDING_MODS_SPLIT_LEVEL,
  BUILDING_MODS_STRONG_COLUMN_WEAK_BEAM,
  BUILDING_MODS_WELD_STRENGTH,
  PLAN_TORSION,
  VERTICAL_IRREGULARITY,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import BuildingModifiersChecklistSection from './BuildingModifiersChecklistSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { selectFormFieldVisibility } = modelTypesByForm[ownProps.form];
  const getVisibilityObjectFromField = name => ({
    [name]: selectFormFieldVisibility(state)(name),
  });

  const fields = [
    BUILDING_MODS_COLUMN_PIER_SPANDREL_RATIO,
    BUILDING_MODS_COLUMN_RATIO_LESS_THAN_TYPICAL,
    BUILDING_MODS_CONSTRUCTION_QUALITY,
    BUILDING_MODS_CROSS_GRAIN_OOP_CONN,
    BUILDING_MODS_DIAPHRAGM_DEFICIENCY,
    BUILDING_MODS_DIAPHRAM_OPEN,
    BUILDING_MODS_FLAT_PLATE_AS_BEAM,
    BUILDING_MODS_FULL_STORY_GRADE,
    BUILDING_MODS_FULL_STORY_GRADE_WLF,
    BUILDING_MODS_INTERIOR_WALL_DENSITY,
    BUILDING_MODS_K_BRACING,
    BUILDING_MODS_LIFT_SLAB_CONSTRUCTION,
    BUILDING_MODS_MATERIAL_DETERIORATION,
    BUILDING_MODS_NON_PARALLEL,
    BUILDING_MODS_NON_STRUCTURAL_CONSTRUCTION_QUALITY,
    BUILDING_MODS_OOP_OFFSET,
    BUILDING_MODS_OTHER_PLAN_IRREGULARITY,
    BUILDING_MODS_OTHER_VERTICAL_IRREGULARITY,
    BUILDING_MODS_PANEL_ZONE_DEFICIENCY,
    BUILDING_MODS_POUNDING_DIFFERENT_BUILDING_HEIGHTS,
    BUILDING_MODS_POUNDING_END_OF_BLOCK,
    BUILDING_MODS_POUNDING_FLOORS_UNALIGNED,
    BUILDING_MODS_REDUNDANCY,
    BUILDING_MODS_REENTRANT,
    BUILDING_MODS_SETBACK_INBOARD,
    BUILDING_MODS_SETBACK_IN_PLANE_LFRS,
    BUILDING_MODS_SETBACK_OUTBOARD,
    BUILDING_MODS_SPLIT_LEVEL,
    BUILDING_MODS_STRONG_COLUMN_WEAK_BEAM,
    BUILDING_MODS_WELD_STRENGTH,
    PLAN_TORSION,
    VERTICAL_IRREGULARITY,
  ];

  const fieldsVisibility = fields.reduce(
    (acc, curr) => ({
      ...acc,
      ...getVisibilityObjectFromField(curr),
    }),
    {}
  );

  return {
    fieldsVisibility,
  };
};

export default connect(mapStateToProps)(BuildingModifiersChecklistSection);
